import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../services/shared.service";

@Component({
  selector: "app-metadata-blocco",
  templateUrl: "./metadata-blocco.component.html",
  styleUrls: ["./metadata-blocco.component.css"],
})
export class MetadataBloccoComponent implements OnInit {
  isLoading: boolean;
  blocco: any;
  tipo: string;

  constructor(private _sharedService: SharedService) {}

  ngOnInit() {}

  inizializeForm() {
    this.getBlocco();
    this.isLoading = false;
  }

  getBlocco() {
    this.blocco = this._sharedService.getBlocco();
    this.tipo = this.blocco.tipoBlocco
      ? this.blocco.tipoBlocco
      : this.blocco.codiceBloccoTipo;
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-manager/metadata-blocco/metadata-blocco.component.ts